import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, PLATFORM_ID, LOCALE_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { VdiService } from './vdi.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { environment } from '../../environments/environment';
import { Page, Settings, SimplePage } from '../shared/navigation/pages.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { utils } from '../shared/helpers/utils';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { UserService } from '../user/user.service';
import { AuthService, UserState } from '../shared/auth/auth.service';

@Component({
  selector: 'app-vdi',
  templateUrl: 'vdi.component.html',
  styleUrls: ['vdi.component.scss'],
  animations: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class VdiComponent implements OnInit, OnDestroy {

  public page: BehaviorSubject<Page> = new BehaviorSubject(new Page);
  public cdn = environment.cdn;
  public settings: Settings = new Settings;
  public countries = utils.countries;

  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loading_vin: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loading_vin_client: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public sent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public search_result: BehaviorSubject<number> = new BehaviorSubject(0);
  public allowed: BehaviorSubject<number> = new BehaviorSubject(0);
  public result:string;
  public resultMessage:string;
  public form: FormGroup;
  public searchForm: FormGroup;
  public form_name = '';
  public came_from = '-';

  public uploader: FileUploader = new FileUploader({});
  public uploaded: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public errored: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public hasBaseDropZoneOver = false;
  public photoExtensions = ['jpg', 'png'];
  public filesExtensions = ['txt', 'pdf', 'docx', 'doc', 'xls', 'xlsx', 'rtx'];
  public dir = 'generate';
  public loading_file: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public path_rules = '';

  private gallery_fetch = true;

  public folders: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(@Inject(LOCALE_ID) public localeId: string, private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private vdiService: VdiService,
    private navigationService: NavigationService, private userService: UserService, public auth: AuthService, private cdr: ChangeDetectorRef) {
    }

  ngOnInit() {
    this.form_name = 'Formularz VDI';
    this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
        this.navigationService.item(this.route.snapshot.data.id).pipe(take(1)).subscribe((p: any) => {
          this.page.next(p);
          this.path_rules = this.router.config.find(x => x.data?.template === p.extra_field_3)?.path || '';
      });


      this.navigationService.pages_files({id: this.route.snapshot.data.id}).pipe(take(1)).subscribe(folders => {
        this.folders.next(folders);
      });

      this.createForm();
      this.createSearchForm();
      this.setOptions();
      this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
      this.uploader.onCompleteAll = () => this.onCompleteAll();
    });
    
  }

  createForm() {
    this.form = this.fb.group({
      vin: ['', [Validators.required, Validators.pattern('^[A-HJ-NPR-Z0-9]{17}$')]],
      type: ['new'],
      photos_directory: 'generate',
      form_name: [this.form_name],
      rodo: ['', Validators.requiredTrue],
      rodo1: ['', Validators.requiredTrue],
      click: [this.navigationService.getClickId().value?.click]
    });

    this.form.get('vin').valueChanges.pipe(debounceTime(300)).subscribe(val => {
      this.allowed.next(0);
      if (val && this.form.get('vin').valid) {
        this.loading_vin.next(true);
        this.vdiService.vdi_search_pw(val).pipe(take(1)).subscribe(result => {
          if (result) {
            this.allowed.next(1);
          }else {
            this.allowed.next(2);
          }
          this.loading_vin.next(false);
        });
      }
    });

    this.form.get('type').valueChanges.subscribe(val => {
      if (val == 'old') {
        if (this.gallery_fetch) {
          this.gallery_fetch = false;
          this.navigationService.gallery(this.page.value.photos_directory).pipe(take(1)).subscribe((result: any) => {
            const page = this.page.value;
            page.gallery = result.items;
            this.page.next(page);
            this.cdr.detectChanges();
          }, error => {
      
          }
          );
        }
      }
    });
  }

  createSearchForm() {
    this.searchForm = this.fb.group({
      vin: ['', [Validators.required, Validators.pattern('^[A-HJ-NPR-Z0-9]{17}$')]]
    });

    this.searchForm.get('vin').valueChanges.pipe(debounceTime(300)).subscribe(val => {
      if (val && this.searchForm.get('vin').valid) {
        this.loading_vin_client.next(true);
        this.vdiService.vdi_search(val).pipe(take(1)).subscribe(result => {
          if (result) {
            this.search_result.next(1);
          } else {
            this.search_result.next(2);
          }
          this.loading_vin_client.next(false);
        });
      }
    });
  }

  submit() {
    const type = this.form.get('type').value;
    if (this.form.status === 'VALID' && (this.allowed.value == 1) && ((this.uploaded.value.length >= 4 && type == 'old') || type == 'new')) {
      this.loading.next(true);
      const formModel = this.form.value;
      formModel.extra_1 = formModel.vin;
      this.vdiService.save(formModel).subscribe((result: any) => {
        this.sent.next(true);
        this.result = result.type;
        this.resultMessage = result.message;
        this.loading.next(false);
      }, error => {
        this.result = 'error';
        this.resultMessage = 'Wystąpił nieznany błąd - spróbuj ponownie.';
        this.loading.next(false);
      }
      );
    } else {
      // if (!this.form.controls.rodo.valid) {
        this.form.controls.rodo.markAsDirty();
      // }
    }
  }

  setOptions() {
    const options = {
      url: environment.api + '/upload',
      additionalParameter: { module: 'vdi', dir: this.form.controls.photos_directory.value, limit: 4, miniatures: {} },
      queueLimit: 4
    };
    this.uploader.setOptions(options); //  = new FileUploader(options);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const res = JSON.parse(response);

    if (res.message === 'error') {
      let error = '';
      switch(+res.upload_code) {
        case 1:
        case 2:
          error =  $localize `:@@upload_error_1:Maksymalny rozmiar pliku został przekroczony`;
          break;
        case 3:
          error =  $localize `:@@upload_error_2:Twój plik został wgrany częściowo - spróbuj ponownie`;
          break;
        case 4:
          error =  $localize `:@@upload_error_3:Pliku nie udało się przesłać`;
          break;
        case 6:
        case 7:
        case 8:
          error =  $localize `:@@upload_error_4:Nie udało się zapisać pliku - skontaktuj się z nami e-mailowo`;
          break;
      }
      this.errored.next([...this.errored.getValue(), item.file.name]);
    } else {
      this.uploaded.next([...this.uploaded.getValue(), item.file.name]);
      this.form.controls.photos_directory.setValue(res.dir);
      this.setOptions();
    }
  }

  onCompleteAll() {
    this.loading_file.next(false);
    this.uploader.clearQueue();
  }

  fileDropped(e: any): void {
      this.loading_file.next(true);
      this.uploader.uploadAll();
  }

  ngOnDestroy() {
  }

}
